import { NextPage, NextPageContext } from 'next';
import React from 'react';
import { ImageBlog } from 'images/blog';
import { HeroPostSingle, PostSingle, RelatedPosts } from 'templates/blog-single';
import { BlogSubscribeForm } from 'templates/blog';
import services from 'services';
import { Post } from 'services/blog/types';

interface PostPageProps {
  post: Post;
  relatedPosts: Post[];
}

const PostPage: NextPage<PostPageProps> = (props) => {
  const { post, relatedPosts } = props;

  return (
    <>
      <HeroPostSingle bgImage={ImageBlog} />
      <PostSingle post={post} />
      <RelatedPosts relatedPosts={relatedPosts} />
      <BlogSubscribeForm />
    </>
  );
};

export const getServerSideProps = async (ctx: NextPageContext): Promise<unknown> => {
  const { id } = ctx.query;
  const { blogService } = services;
  const post = await blogService.getOnePost(String(id));
  const relatedPosts = await blogService.getRelatedPosts(post);

  return {
    props: { post, relatedPosts },
  };
};

export default PostPage;
